import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faInfo, faFileExclamation, faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { Accordion } from 'react-bootstrap';
import { faCircleCheck, faCircleMinus } from '@fortawesome/pro-duotone-svg-icons';
import React, { useState } from 'react';
import { useGetSearchQuestionPropertiesMutation } from '../../../../../../../features/authentication/questionSearchApiSlice';
import CustomToast from '../../../../../../../components/Toast';
import QuestionPropertiesModal from '../../QuestionPropertiesModal';
import { useAssignmentContext } from '../../../../../../../pages/assignments/context';
import AssignmentsUsedBy from '../../../../AssignmentsUsedBy';
import QuestionPreviewBasicModal from '../../../../QuestionPreviewBasicModal';
import ActivityTypes from '../../../../../../../enums/activityTypes';

const QuestionThumbnail = ({ questionDetails, selectedQuestions, setSelectedQuestions, removeOnly, setDateBasedKey, viewMode }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [propertiesResult, setPropertiesResult] = useState({});
  const [getQuestionPropertiesCall] = useGetSearchQuestionPropertiesMutation();
  const [showQuestionPropertiesModal, setShowQuestionPropertiesModal] = useState(false);
  const [questionModalDetails, setQuestionModalDetails] = useState({});
  const [showUsedByModal, setShowUsedByModal] = useState(false);
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const { setHasPendingChanges } = useAssignmentContext();
  const titledResourcesCount = questionDetails.resources?.filter(r => r.selectionTitle)?.length || 0;
  const handleGetQuestionProperties = async (e, question) => {
    setIsLoading(true);
    e?.stopPropagation();
    setShowQuestionPropertiesModal(true);

    if (question.questionId == propertiesResult.data?.questionId) return;

    const options = {
      questionId: question.questionId,
      questionSource: question.questionSource
    };
    const response = await getQuestionPropertiesCall(options);
    if (response.error) {
      CustomToast('Could not get question properties', 'error');
      setShowQuestionPropertiesModal(false);
    }
    else {
      setPropertiesResult(response);
    }
    setIsLoading(false);
  };

  const handleSelectQuestion = (questionDetails, e) => {
    e.stopPropagation();
    if (!questionDetails.isSelected && selectedQuestions.length >= 100) {
      CustomToast('You have already reached the maximum number of questions', 'error');
      return;
    }

    questionDetails.isSelected = !questionDetails.isSelected;
    if (questionDetails.isSelected) {
      setSelectedQuestions([...selectedQuestions, questionDetails]);
      setHasPendingChanges(true);
    } else {
      setSelectedQuestions(selectedQuestions.filter(q => `${q.questionType}${q.questionId}` != `${questionDetails.questionType}${questionDetails.questionId}`));
      setHasPendingChanges(selectedQuestions.filter(q => `${q.questionType}${q.questionId}` != `${questionDetails.questionType}${questionDetails.questionId}` && !q.inAssignment).length > 0);
    }
    setDateBasedKey(new Date().getTime().toString());
  };

  const handleGetUsedByDetails = (e) => {
    e.stopPropagation();
    setShowUsedByModal(true);
  };

  function getSelectionTitle(selectionTitle, index, totalCount) {
    if (!selectionTitle) return selectionTitle;
    const cleanName = removePTags(selectionTitle);
    return totalCount > 1 ? `${cleanName} (${index + 1})` : cleanName;
  }

  function removePTags(inputString) {
    return inputString.replace(/^<p>|<\/p>$/g, '');
  }

  return (
    <>
      <div className={`questionThumbnail ${viewMode > 0 && 'thumbnailHeight'} cursor-pointer`} onClick={() => !questionDetails.blockedText && (setQuestionModalDetails(questionDetails), setShowQuestionModal(true))}>
        <div className='buttonContainer' >
          <div className='topBtnsContainer topSmall'>
            {questionDetails.blockedText == null &&
              <div className='editInfoBtn' onClick={(e) => handleGetQuestionProperties(e, questionDetails)}>
                <FontAwesomeIcon style={{ fontSize: '16px' }} icon={faInfo} />
                <div className='editInfoDescription'>Properties</div>
              </div>
            }

            {questionDetails?.usedBy?.length > 0 &&
              <div className='editInfoBtn mt-3' onClick={(e) => handleGetUsedByDetails(e)}>
                <FontAwesomeIcon style={{ fontSize: '16px' }} icon={faFileExclamation} />
                <div className='editInfoDescription'>Used in an assignment</div>
              </div>
            }
          </div>

          <div className='selectBtns'>
            <div className='d-flex flex-row justify-content-between'>
              {/* <div className='questionThumbnailButtons' style={{ background: '#EDF5FF' }}><FontAwesomeIcon color='#82A9E2' style={{ fontSize: '16px' }} icon={faLink} /></div> */}
              {/* Below is place holder for Link - Uncomment line above for link icon */}
              <div style={{ height: '30px', width: '30px' }}></div>
              {questionDetails.inAssignment &&
                <div className='questionThumbnailButtons' style={{ cursor: 'default' }} onClick={(e) => { e.stopPropagation(); }}>
                  <OverlayTrigger
                    key="editToolTip"
                    placement="top"
                    overlay={<Tooltip className="custom-tooltip">Question in assignment</Tooltip>}>
                    <FontAwesomeIcon style={{ '--fa-primary-color': '#FFFFFF', '--fa-secondary-color': (removeOnly ? '#F79E9E' : '#9EDBC9'), '--fa-secondary-opacity': '1' }} icon={removeOnly ? faCircleMinus : faCircleCheck} />
                  </OverlayTrigger>
                </div>
              }

              {!questionDetails.inAssignment && !questionDetails.blockedText &&
                <div className='questionThumbnailButtons' onClick={(e) => { handleSelectQuestion(questionDetails, e); }}>
                  {questionDetails.isSelected ?
                    <OverlayTrigger
                      key="editToolTip"
                      placement="top"
                      overlay={<Tooltip className="custom-tooltip">Unselect Question</Tooltip>}>
                      <FontAwesomeIcon style={{ '--fa-primary-color': '#FFFFFF', '--fa-secondary-color': (removeOnly ? '#F84646' : '#52C9A5'), '--fa-secondary-opacity': '1' }} icon={removeOnly ? faCircleMinus : faCircleCheck} />
                    </OverlayTrigger>
                    :
                    <OverlayTrigger
                      key="editToolTip"
                      placement="top"
                      style={{ zIndex: 10 }}
                      overlay={<Tooltip className="custom-tooltip">Select Question</Tooltip>}>
                      <FontAwesomeIcon color='#d4deff' icon={faCircle} />
                    </OverlayTrigger>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div className='d-flex flex-column overflow-hidden' >
          <div style={{ fontSize: '0.85em' }}>{`ID: ${questionDetails.questionSource ? questionDetails.questionSource : ''}${questionDetails.questionId}`}</div>
          <div style={{ fontSize: '0.85em' }}>{!questionDetails.blockedText && `${questionDetails.answer ? `Answer: ${questionDetails.answer}` : ''} [Level: ${questionDetails.level}, Correct: ${questionDetails.correct}, Incorrect: ${questionDetails.incorrect}]`}</div>
          <div className='my-1' style={{ border: '1px solid #E7EDFF' }}></div>
          <div className={viewMode == 1 ? 'zoom-9' : viewMode == 2 ? 'zoom-7' : ''}>
            {questionDetails.resources?.length >= 1 &&
            <div className='mb-3'>
              {(() => {
                let titledIndex = 0; // counts only resources that have a selectionTitle
                return questionDetails.resources.map((resource, index) => {

                  if (resource.description.toLowerCase().includes('document missing')) {
                    return (
                      <div key={`docMissing${index}`} className='text-danger'>{resource.description}</div>
                    );
                  }

                  const currentTitledIndex = resource.selectionTitle ? titledIndex++ : null;


                  return (
                    <React.Fragment key={`resource${index}`}>
                    
                      {resource.selectionTitle &&
                      <Accordion key={`resource${index}`}>
                        <Accordion.Header>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: getSelectionTitle(resource.selectionTitle, currentTitledIndex, titledResourcesCount),
                            }}
                          ></div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div dangerouslySetInnerHTML={{ __html: resource.description }}></div>
                        </Accordion.Body>
                      </Accordion>
                      }

                      {!resource.selectionTitle && !resource.mp3Path &&
                          <div dangerouslySetInnerHTML={{ __html: resource.description }}></div>
                      }
                    
                      {resource.imagePath &&
                          <img src={resource.imagePath }></img>
                      }
                      {!resource.selectionTitle && resource.mp3Path &&
                      <div className='d-flex flex-column'>
                        {resource.description && <div className='border-black p-1' dangerouslySetInnerHTML={{ __html: resource.description }}></div>}
                        {resource.mp3Path && 
                         <>
                           <audio style={{ maxWidth: '98%' }} controls='controls' src={resource.mp3Path} type='audio/mpeg' ></audio>
                           <div className="d-flex align-items-center gap-2 mt-3 mb-2 audio-notice">
                             <FontAwesomeIcon icon={faCircleInfo} className="text-primary" />
                             <span className='audio-notice-description'>&quot;Students will not see the reading selection text and will have to listen to the audio file.&quot;</span>
                           </div>
                         </>
                        }
                      </div>}

                      {!resource.selectionTitle && resource.mp4Path &&
                      <div style={{ border: '1px solid black', padding: '5px', width: '75%' }}>
                        This question contains a video.  Click to view.
                      </div>
                      }
                    </React.Fragment>
                  );
                });
              })()}
            </div>
            }
            {questionDetails.blockedText ?
              <div className='text-danger fw-semibold fs-6' dangerouslySetInnerHTML={{ __html: questionDetails.blockedText }}></div>
              :
              <>
                {questionDetails.question &&
                <div dangerouslySetInnerHTML={{ __html: questionDetails.question }}></div>
                }

                {questionDetails.sampleAnswer ?
                  <>
                    <div className='mt-2 mb-1 fw-bold'>Sample Answer</div>
                    <div dangerouslySetInnerHTML={{ __html: questionDetails.sampleAnswer }}></div>
                  </> : <></>}
              </>
            }
          </div>
        </div>
      </div>

      {showQuestionPropertiesModal &&
        <QuestionPropertiesModal
          setShowQuestionPropertiesModal={setShowQuestionPropertiesModal}
          showQuestionPropertiesModal={showQuestionPropertiesModal}
          propertiesResult={propertiesResult}
          setPropertiesResult={setPropertiesResult}
          isSearchQuestion={true}
          handleSelectQuestion={handleSelectQuestion}
          questionModalDetails={questionDetails}
          isLoading={isLoading}
        />
      }

      <AssignmentsUsedBy
        usedAssignments={questionDetails.usedBy}
        showUsedByModal={showUsedByModal}
        setShowUsedByModal={setShowUsedByModal}
        activityType={ActivityTypes.Assignment}
      />

      <QuestionPreviewBasicModal
        isOpen={showQuestionModal}
        onClose={setShowQuestionModal}
        details={questionModalDetails}
        fromQuestionSearch={true}
        handleSelectQuestion={handleSelectQuestion}
        isLoading={false}
      />
    </>
  );
};

QuestionThumbnail.propTypes = {
  questionDetails: PropTypes.object.isRequired,
  defaultChecked: PropTypes.bool,
  selectedQuestions: PropTypes.array,
  setSelectedQuestions: PropTypes.func,
  removeOnly: PropTypes.bool,
  setDateBasedKey: PropTypes.func,
  viewMode: PropTypes.number
};

export default QuestionThumbnail;